<template>
  <div class="h-full bg-transparent">
    <div class="hidden sm:flex h-full flex-col justify-between">
      <div class=" h-full hidden sm:flex flex-col">
        <div class="p-6 pr-4 flex justify-between">
          <h1 class="text-white text-2xl font-bold">FLORA Admin</h1>
          <div class="w-10 bg-white rounded">
            <img alt="" src="../assets/favicon.png">
          </div>

        </div>
        <div class="  text-white w-full px-4">
          <p :class="{ active: (activeComponent === 'ContentMain') }" @click="goToAllStates"
             class=" text-xl hover:bg-purple py-2 pl-2 mb-2  flex justify-between cursor-pointer">
            States
            <span class="pr-3 self-center">
            <ArchiveIcon :class="{ activeIcon: (activeComponent === 'ContentMain') }"/>
          </span>
          </p>
          <p :class="{ active: (activeComponent === 'IsolationIndex') }" @click="goToIsolation"
             class=" text-xl hover:bg-purple py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            Isolation Centres
            <span class="pr-3 self-center">
          <MapIcon :class="{ activeIcon: (activeComponent === 'IsolationIndex') }"/>
        </span>
          </p>
          <p :class="{ active: (activeComponent === 'AreaAffectedIndex') }" @click="goToAffectedAreas"
             class=" text-xl hover:bg-purple py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            Affected
            Areas
            <span class="pr-3 self-center">
          <TargetIcon :class="{ activeIcon: (activeComponent === 'AreaAffectedIndex') }"/>
        </span>
          </p>
          <p :class="{ active: (activeComponent === 'NumberIndex') }" @click="goToNumbers"
             class=" text-xl hover:bg-purple py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            States Contact
            <span class="pr-3 self-center">
          <PhoneIcon :class="{ activeIcon: (activeComponent === 'NumberIndex') }"/>
        </span>
          </p>
          <p :class="{ active: (activeComponent === 'TestIndex') }" @click="goToTest"
             class=" text-xl hover:bg-purple py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            Test Centres
            <span class="pr-3 self-center">
          <ThermometerIcon :class="{ activeIcon: (activeComponent === 'TestIndex') }"/>
        </span>
          </p>
          <p :class="{ active: (activeComponent === 'BlogIndex') }" @click="goToBlog"
             class=" text-xl hover:bg-purple py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            Blog Posts
            <span class="pr-3 self-center">
          <BookIcon :class="{ activeIcon: (activeComponent === 'BlogIndex') }"/>
        </span>
          </p>
        </div>
      </div>
      <div class=" bg-purple_dark opacity-75 shadow ">
        <div class="font-semibold  text-white w-full px-4">
          <p @click="goToSettings"
             class=" text-xl py-2 pb-0 pl-2 mb-2 flex justify-between cursor-pointer">
            Settings
            <span class="pr-3 self-center">
            <SettingsIcon/>
          </span>
          </p>
        </div>
      </div>
    </div>
    <div class=" h-full flex flex-col w-full  sm:hidden h-full flex-col justify-between">
      <div class=" h-full flex flex-col w-full pt-2  sm:hidden">
        <div class="ml-1 w-10">
          <img alt="" src="../assets/favicon.png">
        </div>
        <div class=" w-full text-white">
          <p :class="{ mobileActive: (activeComponent === 'ContentMain') }" @click="goToAllStates"
             class=" text-xl mt-2 m-1 py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            <span class=" self-center">
          <ArchiveIcon/>
        </span>
          </p>
          <p :class="{ mobileActive: (activeComponent === 'IsolationIndex') }" @click="goToIsolation"
             class=" text-xl   m-1 py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            <span class=" self-center">
          <MapIcon/>
        </span>
          </p>
          <p :class="{ mobileActive: (activeComponent === 'AreaAffectedIndex') }" @click="goToAffectedAreas"
             class=" text-xl   m-1 py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            <span class=" self-center">
          <TargetIcon/>
        </span>
          </p>
          <p :class="{ mobileActive: (activeComponent === 'NumberIndex') }" @click="goToNumbers"
             class=" text-xl   m-1 py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            <span class=" self-center">
          <PhoneIcon/>
        </span>
          </p>
          <p :class="{ mobileActive: (activeComponent === 'TestIndex') }" @click="goToTest"
             class=" text-xl   m-1 py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            <span class=" self-center">
          <ThermometerIcon/>
        </span>
          </p>
          <p :class="{ mobileActive: (activeComponent === 'BlogIndex') }" @click="goToBlog"
             class=" text-xl   m-1 py-2 pl-2 mb-2 flex justify-between cursor-pointer">
            <span class=" self-center">
          <BookIcon/>
        </span>
          </p>
        </div>
      </div>
      <div class=" bg-purple_dark opacity-75 shadow ">
        <div class="font-semibold  text-white w-full">
          <p @click="goToSettings"
             class=" text-xl  m-1 py-2 pl-2 mb-2 mb-2 flex justify-between cursor-pointer">
            <span class=" self-center">
            <SettingsIcon/>
          </span>
          </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import {MapIcon, BookIcon, TargetIcon, ArchiveIcon, PhoneIcon, SettingsIcon, ThermometerIcon} from 'vue-feather-icons'
  // import { } from 'vue-feather-icons'
  import {eventBus} from '../eventbus'

  export default {
    name: "SideBar",
    data: () => ({}),
    components: {
      MapIcon, TargetIcon, ArchiveIcon, BookIcon, PhoneIcon, SettingsIcon, ThermometerIcon
    },
    props: {
      activeComponent: {
        type: String,
        required: true
      }
    },
    created() {
      this.listener()
    },
    methods: {
      listener() {
      },
      goToAllStates() {
        eventBus.$emit('State')
      },
      goToIsolation() {
        eventBus.$emit('Isolation')
      },
      goToAffectedAreas() {
        eventBus.$emit('AffectedAreas')
      },
      goToNumbers() {
        eventBus.$emit('Numbers')
      },
      goToSettings() {
        eventBus.$emit('Settings')
      },
      goToTest() {
        eventBus.$emit('Test')
      },
      goToBlog() {
        eventBus.$emit('Blog')
      }
    }
  }
</script>

<style>
  .sideBackground {
    background: #eae2e2;
  }

  .active {
    @apply rounded-lg ml-2 font-semibold shadow;
    background-color: #e4daf6;
    color: #722ded;
  }

  .mobileActive {
    @apply rounded-lg shadow;
    background-color: #e4daf6;
    color: #722ded;
  }

  .activeIcon {
    color: #a67bf4;
  }
</style>
